const IMAGES = [
  { file: "home.jpg", page: "/ (Home)" },
  { file: "cabanas.jpg", page: "/cabanas" },
  { file: "glamping.jpg", page: "/glamping" },
  { file: "tubing.jpg", page: "/tubing" },
  { file: "family-getaways.jpg", page: "/family-getaways-new-braunfels" },
  { file: "property-map.jpg", page: "/property-map" },
  { file: "blog-spring-break.jpg", page: "/blog/spring-break-2026" },
  { file: "blog-best-time.jpg", page: "/blog/best-time-to-tube-guadalupe" },
  { file: "blog-memorial-day.jpg", page: "/blog/memorial-day-2026" },
];

const OGPhotos = () => {
  return (
    <main className="min-h-screen bg-background py-12 px-4">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-4xl font-bold mb-2">OG Image Preview</h1>
        <p className="text-muted-foreground mb-8">
          Open Graph / social share cards (1216×640) used when pages are shared on Google, Facebook, iMessage, etc.
        </p>
        <div className="grid gap-10">
          {IMAGES.map(({ file, page }) => (
            <figure key={file} className="bg-card rounded-2xl overflow-hidden shadow-md">
              <img loading="lazy" decoding="async"
                src={`/og/${file}`}
                alt={`OG card for ${page}`}
                width={1216}
                height={640}
                className="w-full h-auto block"
              />
              <figcaption className="px-5 py-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1">
                <span className="font-medium">{page}</span>
                <code className="text-sm text-muted-foreground">/og/{file}</code>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </main>
  );
};

export default OGPhotos;
